import { render, staticRenderFns } from "./OrganizMarketDataList.vue?vue&type=template&id=724f3718&scoped=true&"
import script from "./OrganizMarketDataList.vue?vue&type=script&scoped=true&lang=js&"
export * from "./OrganizMarketDataList.vue?vue&type=script&scoped=true&lang=js&"
import style0 from "./OrganizMarketDataList.vue?vue&type=style&index=0&id=724f3718&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "724f3718",
  null
  
)

export default component.exports